import classNames from "classnames"
import type {
  ForwardedRef,
  HTMLAttributes,
} from "react"
import { forwardRef } from "react"
import styles from "./Tile.module.scss"

type Props = HTMLAttributes<HTMLDivElement>

/*
 * this component has the same styles as the timeSpan but no content
 *
 * this allows tiles like the TimeInRange tile, which have no TileTimeSpan to
 * render with a similar to layout to the other tiles
 */
export const TileSpacer = forwardRef<HTMLDivElement, Props>(
  function TileSpacer(props: Props, ref: ForwardedRef<HTMLDivElement>) {
    const className = classNames(
      props.className,
      styles.timeSpan,
    )
    return (
      <div
        {...props}
        ref={ref}
        className={className}
      />
    )

  },
)
